import { render, staticRenderFns } from "./X-modale-commentaire.vue?vue&type=template&id=5e498808&scoped=true"
import script from "./X-modale-commentaire.vue?vue&type=script&lang=js"
export * from "./X-modale-commentaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e498808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e498808')) {
      api.createRecord('5e498808', component.options)
    } else {
      api.reload('5e498808', component.options)
    }
    module.hot.accept("./X-modale-commentaire.vue?vue&type=template&id=5e498808&scoped=true", function () {
      api.rerender('5e498808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/time/X-modale-commentaire.vue"
export default component.exports